/**
 * Публичный предпросмотр цены (E09 / E12, ФТ-4 / ФТ-10).
 * Персональная надбавка входит в total, отдельной величиной не отдаётся.
 */

import { z } from "zod";
import { decimalStringSchema } from "./catalog";
import { apiSuccessSchema } from "./envelope";

export const publicPricePreviewRequestSchema = z.object({
  projectId: z.string().uuid(),
  unitId: z.string().uuid(),
});
export type PublicPricePreviewRequest = z.infer<typeof publicPricePreviewRequestSchema>;

export const publicPricePreviewLineSchema = z.object({
  name: z.string().nullable(),
  componentCode: z.string().nullable(),
  lineTotal: decimalStringSchema,
});
export type PublicPricePreviewLine = z.infer<typeof publicPricePreviewLineSchema>;

export const publicPricePreviewResultSchema = z.object({
  accessGranted: z.boolean(),
  accessHint: z.literal("request_required").nullable(),
  total: decimalStringSchema.nullable(),
  lines: z.array(publicPricePreviewLineSchema).nullable(),
});
export type PublicPricePreviewResult = z.infer<typeof publicPricePreviewResultSchema>;

export const publicPricePreviewResultResponseSchema = apiSuccessSchema(
  publicPricePreviewResultSchema,
);

export const PUBLIC_PRICE_ERROR_CODES = {
  PROJECT_NOT_FOUND: "PUBLIC_PRICE_PROJECT_NOT_FOUND",
  NO_CLIENT: "PUBLIC_PRICE_NO_CLIENT",
  UNIT_NOT_FOUND: "PUBLIC_PRICE_UNIT_NOT_FOUND",
  NO_PUBLISHED_BOM: "PUBLIC_PRICE_NO_PUBLISHED_BOM",
} as const;
export type PublicPriceErrorCode =
  (typeof PUBLIC_PRICE_ERROR_CODES)[keyof typeof PUBLIC_PRICE_ERROR_CODES];
